import React from 'react';
import { Plus, SlidersHorizontal } from 'lucide-react';
import { Panel } from '../../bodas/admin/comunes';
import EditorGrupo from './EditorGrupo';
import { claveDe, mover, nuevoGrupo } from './tiendaAdminApi';

export default function OpcionesPersonalizacion({ grupos, setGrupos }) {
  const cambiar = (i, g) => setGrupos(grupos.map((x, j) => (j === i ? g : x)));
  const eliminar = (i) => window.confirm(`¿Eliminar el grupo «${grupos[i].nombre || 'sin nombre'}» y sus opciones? Los pedidos ya realizados las conservan.`)
    && setGrupos(grupos.filter((_, j) => j !== i));

  return (
    <Panel className="space-y-4 p-5" testId="tienda-opciones-personalizacion">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-semibold text-slate-800"><SlidersHorizontal className="h-5 w-5 text-amber-600" />Opciones de personalización</h2>
        <p className="text-sm text-slate-500">Crea los grupos que el cliente elige (cuello, manga, tela, iniciales…). Se muestran en este orden.</p>
      </div>
      {grupos.length === 0 && <p className="rounded-lg bg-slate-50 p-4 text-sm text-slate-500">Este producto aún no tiene opciones de personalización.</p>}
      {grupos.map((g, i) => (
        <EditorGrupo key={claveDe(g)} grupo={g} indice={i} total={grupos.length} testId={`tienda-grupo-${i}`}
          onCambiar={v => cambiar(i, v)} onMover={d => setGrupos(mover(grupos, i, d))} onEliminar={() => eliminar(i)} />
      ))}
      <button type="button" onClick={() => setGrupos([...grupos, nuevoGrupo()])}
        className="inline-flex items-center gap-2 rounded-lg bg-slate-800 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-700" data-testid="tienda-agregar-grupo">
        <Plus className="h-4 w-4" />Agregar grupo de opciones
      </button>
    </Panel>
  );
}
